export default __webpack_public_path__ + "static/hifimap1-ccc1437feab86299766fe50a0fd50b34.png";